import { useState } from "react";
import { ReactCompareSlider, ReactCompareSliderHandle } from "react-compare-slider";
import { MoveHorizontal, ImagePlus } from "lucide-react";

/* Slider avant/après avec placeholders.
   TODO: Remplacer par photo réelle chantier Brandon.
   NE PAS générer d'image IA. NE PAS utiliser d'image stock. */
const PlaceholderPane = ({ label }) => (
  <div className="photo-placeholder" style={{ aspectRatio: "4/5" }}>
    <span className="w-11 h-11 rounded-full bg-brand-highlight flex items-center justify-center">
      <ImagePlus size={20} className="text-brand-royal" aria-hidden="true" />
    </span>
    <span className="font-medium text-ink-secondary">Photo à venir</span>
    <span className="dashed-zone">{label}</span>
  </div>
);

export const BeforeAfter = ({ beforeSrc, afterSrc, alt = "" }) => {
  const [dragged, setDragged] = useState(false);

  return (
    <div className="relative rounded-xl overflow-hidden" style={{ aspectRatio: "4/5" }} onPointerDown={() => setDragged(true)}>
      <ReactCompareSlider
        position={55}
        style={{ height: "100%", width: "100%" }}
        handle={
          <ReactCompareSliderHandle
            buttonStyle={{ background: "linear-gradient(135deg, #1E4FA8 0%, #4A82D6 100%)", border: "2px solid #fff", width: 40, height: 40, boxShadow: "0 4px 12px rgba(10,37,64,0.25)" }}
            linesStyle={{ width: 2, background: "rgba(255,255,255,0.9)" }}
          />
        }
        itemOne={
          beforeSrc ? (
            <img src={beforeSrc} alt={`Avant — ${alt}`} loading="lazy" className="w-full h-full object-cover" />
          ) : (
            <PlaceholderPane label="Avant" />
          )
        }
        itemTwo={
          afterSrc ? (
            <img src={afterSrc} alt={`Après — ${alt}`} loading="lazy" className="w-full h-full object-cover" />
          ) : (
            <PlaceholderPane label="Après" />
          )
        }
      />
      {!dragged && (
        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 pointer-events-none flex items-center gap-2 bg-brand-deep/85 text-white text-xs font-medium px-4 py-2 rounded-full">
          <MoveHorizontal size={14} aria-hidden="true" />
          Glissez
        </div>
      )}
    </div>
  );
};
